import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Observable, Subject, of } from 'rxjs';
import {
  debounceTime,
  distinctUntilChanged,
  filter,
  switchMap,
  takeUntil,
  map,
  catchError,
} from 'rxjs/operators';
import { ClientService } from '../../clients/client.service';
import { Organization, Client } from '../../shared/sdk';
import {
  NgbTypeaheadSelectItemEvent,
  NgbModal,
} from '@ng-bootstrap/ng-bootstrap';
import { ClientAddComponent } from '../../clients/client-add/client-add.component';
import {
  trigger,
  state,
  style,
  transition,
  group,
  animate,
} from '@angular/animations';

@Component({
  selector: 'app-document-client-select',
  templateUrl: './document-client-select.component.html',
  styleUrls: ['./document-client-select.component.css'],
  animations: [
    trigger('slideInOut', [
      state('in', style({ height: '*', opacity: 0 })),
      transition(':enter', [
        style({ height: '0', opacity: 0 }),

        group([
          animate(200, style({ height: '*' })),
          animate('250ms ease-in-out', style({ opacity: '1' })),
        ]),
      ]),
    ]),
  ],
})
export class DocumentClientSelectComponent implements OnInit, OnDestroy {
  @Input() _documentClientCtrl: FormGroup;
  @Input() activeOrg: Organization;
  @Input() clientIdCtrl: FormControl;
  @Input() compact = false;
  @Input() editable = true;
  @Input() isDocumentClient: boolean;
  @Input() title: string;
  @Input() sent: boolean;
  loading: any = {};
  private onDestroy$: Subject<void> = new Subject();

  constructor(
    private clientService: ClientService,
    private modalService: NgbModal,
  ) {}

  ngOnInit() {}

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  clientSearch = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      filter((term) => term.length > 1),
      switchMap((term: string) =>
        this.findClients(term).pipe(catchError((_) => of([]))),
      ),
      takeUntil(this.onDestroy$),
    );

  onSelectClient(match: NgbTypeaheadSelectItemEvent) {
    const client = match.item;

    if (client.id) {
      this._documentClientCtrl.reset();
      this.clientIdCtrl.setValue(client.id);
      this._documentClientCtrl.patchValue(new Client(client));
      this.clientIdCtrl.markAsDirty();
      // Out event?
      // this.matchPriceListToClient(client.id);
    } else {
      // Cliecked on add new ... item
      this.onShowClientAddModal(client);
    }

    // Prevent item being set to form control again since we just updated it
    match.preventDefault();
  }

  onShowClientAddModal(data?: any) {
    const client: Client = data || this._documentClientCtrl.value || {};
    const clientId = this.clientIdCtrl.value;
    client.id = clientId;

    const modalRef = this.modalService.open(ClientAddComponent, {
      size: 'lg',
    });

    modalRef.componentInstance.client = client;
    // Prevents saving client as new when editing existing document's client
    modalRef.componentInstance.isDocumentClient =
      clientId && this.isDocumentClient;

    modalRef.result
      .then((newClient: Client) => {
        if (newClient) {
          this.onSelectClient({ item: newClient, preventDefault: () => {} });
        }

        // if (this.docForm.get('validateEslog').value) {
        //   const { clientMissingInfo } = this.validateEslog();
        //   this.clientMissingInfo = clientMissingInfo;
        // }
      })
      .catch(() => {});
  }

  onUnsetClient() {
    this.clientIdCtrl.reset();
    // this.clientSearchCtrl.reset();
    this._documentClientCtrl.reset();

    // this.priceListsFiltered = this.priceLists.filter(pl => !pl.clientId);

    // const plCtrl = this.priceListIdCtrl;
    // const selectedPlId = plCtrl.value;
    // const pl = this.priceLists.find(pl => pl.id === selectedPlId);
    // if (pl) {
    //   plCtrl.patchValue('');
    // }
  }

  private findClients(term: string): Observable<any> {
    this.loading.clients = true;

    return this.clientService.find(this.activeOrg.id, term, 'supplier').pipe(
      map(({ body }) => body),
      map((clients: Client[]) => {
        this.loading.clients = false;
        const list = [...clients, { name: term }];
        return list;
      }),
    );
  }
}
